import axios from 'axios'
import { Message } from 'element-ui'
import router from '../router'

const TOKEN_KEY = 'admin_jwt'

export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || ''
}

export function setToken(t) {
  if (t) localStorage.setItem(TOKEN_KEY, t)
  else localStorage.removeItem(TOKEN_KEY)
}

const apiBase = (process.env.VUE_APP_API_BASE || '').trim().replace(/\/$/, '')

const service = axios.create({
  // .env.* 中 VUE_APP_API_BASE，如 https://api.loanmax.top；留空则相对路径 + devServer 代理本机 API
  baseURL: apiBase || '/',
  timeout: 30000,
})

service.interceptors.request.use(
  (config) => {
    const token = getToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    // 与 H5 一致：用 Accept-Language 传语言，避免自定义头触发 CORS 预检被旧 Nginx 拦截
    config.headers['Accept-Language'] = 'zh-CN;q=1, zh-Hans;q=0.9, zh;q=0.8'
    return config
  },
  (err) => Promise.reject(err),
)

service.interceptors.response.use(
  (res) => {
    const body = res.data
    if (body && typeof body.code === 'number' && body.code !== 0) {
      const msg = body.msg || '请求失败'
      Message.error(msg)
      if (body.code === 401) {
        setToken('')
        router.replace({ name: 'Login' })
      }
      // 业务错误用普通对象 reject，避免 dev 环境整页 Uncaught runtime errors 遮罩
      return Promise.reject({ isApiError: true, code: body.code, msg })
    }
    return body
  },
  (err) => {
    const msg = err.response?.data?.msg || err.message || '网络错误'
    Message.error(msg)
    if (err.response?.status === 401) {
      setToken('')
      router.replace({ name: 'Login' })
    }
    return Promise.reject(err)
  },
)

export default service
